import gql from 'graphql-tag';

export const deleteCommercialFacility = gql`
  mutation deleteCommercialFacility($id: ID!) {
    deleteCommercialFacility(id: $id) {
      value
    }
  }
`;
